import { History, MoreHorizontal, Pencil, Plus, Settings2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { StandardContractView } from '../contract-types';

interface StandardContractRowActionsProps {
  contract: StandardContractView;
  onConfigure?: (contract: StandardContractView) => void;
  onEdit?: (contract: StandardContractView) => void;
  onShowHistory?: (contract: StandardContractView) => void;
  onPublishVersion?: (contract: StandardContractView) => void;
}

export function StandardContractRowActions({
  contract,
  onConfigure,
  onEdit,
  onShowHistory,
  onPublishVersion,
}: StandardContractRowActionsProps) {
  const isConfigured = contract.version !== null;

  if (!isConfigured) {
    return (
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 text-xs"
        onClick={() => onConfigure?.(contract)}
        disabled={!onConfigure}
      >
        <Settings2 className="h-3.5 w-3.5 mr-1.5" />
        Configurar Contrato
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Abrir ações de {contract.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem disabled={!onEdit} onSelect={() => onEdit?.(contract)}>
          <Pencil className="h-4 w-4 mr-2" />
          Editar
        </DropdownMenuItem>
        <DropdownMenuItem disabled={!onShowHistory} onSelect={() => onShowHistory?.(contract)}>
          <History className="h-4 w-4 mr-2" />
          Histórico
        </DropdownMenuItem>
        <DropdownMenuItem
          disabled={!onPublishVersion}
          onSelect={() => onPublishVersion?.(contract)}
        >
          <Plus className="h-4 w-4 mr-2" />
          Criar nova versão
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
